import SwitchFormHandle from '../containers/forms/switch/SwitchFormHandle';
import VisaBasellFormHandle from '../containers/forms/visaBasell/VisaBasellFormHandle';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';

const SwitchAndVisaBasell = () => {
  return (
    <CC.Flex direction={{base: 'column', sm: 'column'}}>
      <SwitchFormHandle />
      <VisaBasellFormHandle />
    </CC.Flex>
  )
}

export default SwitchAndVisaBasell